var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3917 8.81078L15.3916 8.81069L15.3839 8.81991L10.3839 14.8198C10.3395 14.8732 10.2844 14.9167 10.2222 14.9476C10.1599 14.9784 10.092 14.996 10.0226 14.9992C9.9532 15.0023 9.88391 14.991 9.81915 14.9659C9.75444 14.9408 9.69566 14.9025 9.64655 14.8534C9.64652 14.8534 9.64648 14.8534 9.64645 14.8533L6.65014 11.857C6.56064 11.763 6.51118 11.6378 6.51231 11.5079C6.51345 11.3768 6.56603 11.2514 6.65873 11.1587C6.75144 11.066 6.87684 11.0134 7.00794 11.0123C7.13783 11.0112 7.263 11.0606 7.35701 11.1501L9.57837 13.3725L9.96548 13.7598L10.3161 13.3391L14.6161 8.18013L14.6162 8.18022L14.6237 8.17078C14.6651 8.11855 14.7166 8.07514 14.7751 8.0431C14.8335 8.01105 14.8978 7.99103 14.9641 7.9842C15.0304 7.97736 15.0975 7.98386 15.1612 8.00331C15.225 8.02276 15.2842 8.05477 15.3355 8.09745C15.3867 8.14013 15.4288 8.19263 15.4595 8.25185C15.4901 8.31106 15.5086 8.37581 15.5138 8.44227C15.5191 8.50874 15.511 8.57558 15.49 8.63887C15.469 8.70215 15.4356 8.7606 15.3917 8.81078ZM11 0C4.925 0 0 4.925 0 11C0 17.075 4.925 22 11 22C17.075 22 22 17.075 22 11C22 4.925 17.075 0 11 0Z",
    stroke: "#1E8E1B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 20.4,
    height: 20.4,
    rx: 10.2,
    stroke: "#1E8E1B",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.ea484f913931bf55c3fb824b95747bc5.svg";
export { ForwardRef as ReactComponent };